<template>
  <page-wrapper :title="title" :has-pad="true">
    <confirm-dialog
      v-if="confirmDialog.isShow"
      :data="confirmDialog"
      @confirm="handleConfirmDialog"
    />
    <div v-if="!detail" class="text-center p-4">กำลังโหลด</div>
    <div v-else class="wrapper">
      <div v-if="showCancelAction" class="d-flex justify-content-between mb-4">
        <sc-button
          v-if="showCancelButton"
          :disabled="disabledCancelButton"
          variant="danger"
          @click="handleClickCancel"
        >{{ cancelButtonText }}</sc-button>
        <sc-button
          v-if="showUnsubscribeButton"
          :disabled="disabledUnsubscribeButton || isViewOnlyByRole"
          variant="warning"
          @click="handleClickUnsubscribe"
        >ยกเลิกการเป็นสมาชิก Unsubscribe</sc-button>
      </div>
      <div v-if="showRevokeAction" class="d-flex justify-content-end mb-4">
        <sc-button
          :disabled="isViewOnlyByRole"
          variant="secondary"
          @click="handleClickRevoke"
        >Undo การยกเลิก</sc-button>
      </div>
      <div class="row">
        <div class="col-3 member">
          <p v-if="subscriber.isUserForOfflinePurchaseByAdmin === true" class="font-red">*ซื้อนอกระบบลูกค้าไม่โหลด App</p>
          <p v-if="subscriber.isNonVerifySales === true" class="font-red">*ลูกค้าซื้อโดยไม่สมัคร App</p>
          <div class="row mx-0 d-flex justify-content-between justify-items-center align-items-center">
            <p>ชื่อ (ID: {{ subscriber.userId }})</p>
            <ri-link-button :link="ruejaiIntelligenceLink" name="RI Insight/Label"></ri-link-button>
          </div>
          <h6>{{ subscriber.name }}</h6>
          <p>บ้านเลขที่</p>
          <sc-button
            v-show="!$isCallCenter && !hasHome && !isCancelled"
            :disabled="isViewOnlyByRole"
            variant="primary"
            size="sm"
            @click="handleShowSelectHomeDialog"
          >เลือกบ้าน</sc-button>
          <h6>{{ hasHome ? subscriber.home.addressNumber : isCancelled ? "-" : undefined }}</h6>
          <p>โครงการ</p>
          <h6>{{ hasHome ? subscriber.home.project : "-" }}</h6>
          <p>เบอร์โทรศัพท์</p>
          <div>
            <a
              v-if="subscriber.phoneNumber && subscriber.phoneNumber !== '-'"
              :href="`callto://${subscriber.phoneNumber}`"
              class="callto-link"
            >
              <h6>{{ subscriber.phoneNumber }}</h6>
            </a>
            <h6 v-else>-</h6>
          </div>
          <p>E-mail</p>
          <h6>{{ subscriber.email }}</h6>
          <p>เลขบัตรประชาชน / Passport No.</p>
          <div class="mb-3">
            <button
              v-if="!isHiddenDrecryptButton"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="subscriber.identifierNo" class="identifier-id">
              {{  subscriber.identifierNo }}
            </div>
          </div>
          <p>วันเกิด</p>
          <h6>{{ subscriber.dateOfBirth }}</h6>
          <div class="row mb-4">
            <div v-if="histories[0] && histories[0].invoiceId" class="col-lg-12">
              <p>ข้อมูลใบกำกับภาษี</p>
              <div>{{ addressTaxInvoice.line1 }}</div>
              <div>{{ addressTaxInvoice.line2 }}</div>
              <div>
                <sc-button
                  v-if="isShowTaxInvoiceButton"
                  :disabled="isViewOnlyByRole"
                  variant="primary"
                  size="sm"
                  @click="handleClickListAddressButton"
                >จัดการที่อยู่</sc-button>
                <sc-button
                  v-if="isShowTaxInvoiceButton &&
                  addressTaxInvoice.line1 &&
                  histories[0].showSendReceiptButton &&
                  !histories[0].showNoReceiptMessage"
                  variant="danger"
                  size="sm"
                  @click="handleClickCancelUserTaxInvoiceByTransactionButton"
                >ยกเลิกข้อมูลใบกำกับภาษี</sc-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 info">
          <div class="row">
            <div class="col col-lg-6">
              <div v-if="alertDialog.isShow" class="alert alert-danger">{{ alertDialog.message }}</div>
              <div class="id">
                <div>
                  <div class="sub-id">Subscription ID:</div>
                  <div class="fontsize-14">{{ subscriber.id }}</div>
                </div>
                <div>
                  <sc-button
                    variant="orange-cc"
                    size="sm"
                    @click="handleClickToSubscriberReportPage(subscriber.id)"
                  >การซืื้อทั้งหมดของรายการนี้</sc-button>
                </div>
              </div>
              <div v-if="showNote">
                <p>หมายเหตุ: {{ note.label }}</p>
                <h6>{{ note.content }}</h6>
              </div>
              <p></p>
              <p>สถานะ</p>
              <h6>{{ status }}</h6>
              <div v-if="showPaymentStatus">
                <p>เลขที่ใบสั่งซื้อ</p>
                <h6>{{ subscriber.invoice.id }}</h6>
                <p>สถานะการชำระเงิน</p>
                <h6>{{ paymentStatus }}</h6>
              </div>
              <p>ซื้อเมื่อ</p>
              <h6>{{ subscriber.purchasedAt }}</h6>
              <div v-if="showCancelledDate">
                <p>ยกเลิกเมื่อ</p>
                <h6>{{ subscriber.cancelledAt }}</h6>
              </div>
              <div v-if="showExtras">
                <p>ข้อมูลเพิ่มเติม</p>
                <p>{{ registrationForm.title }}</p>
                <div v-for="extra in registrationForm.extras" :key="extra.key" class="extra">
                  <p>{{ extra.label }}</p>
                  <div v-for="input in extra.inputs" :key="input.key">
                    <p>{{ input.label }}</p>
                    <h6 v-if="input.isText">{{ input.value }}</h6>
                    <a
                      v-else
                      :href="input.value"
                      target="_blank"
                      class="sc-button sm secondary"
                    >ดูรูป</a>
                  </div>
                </div>
              </div>
              <p>ประวัติการต่ออายุ</p>
              <div v-for="history in histories" :key="history.id" class="history">
                <div class="no mb-1">
                  รอบที่ {{ history.no }}
                  <span
                    v-if="history.isFreeTrial"
                    style="font-weight: normal"
                  >(ทดลองใช้)</span>
                </div>
                <div v-if="!history.isFreeTrial" class="row mb-2">
                  <div class="col-6">
                    <strong>เลขที่ใบแจ้งหนี้</strong>
                    <br />
                    {{ history.invoiceNo }}
                  </div>
                  <div class="col-6">
                    <strong>เลขที่ใบเสร็จ</strong>
                    <br />
                    {{ history.receiptNo }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-6">
                    <strong>หมดอายุเมื่อ</strong>
                    <i v-if="detail.current_package.is_expire_after_appointment" style="color:red"><br />
                      <small>*วันเปลี่ยนแปลงตามการนัดครั้งที่ 1</small>
                    </i>
                    <br />
                    {{ history.expiredAt }}
                  </div>
                  <div class="col-6">
                    <strong>มีผลเมื่อ</strong>
                    <i v-if="detail.current_package.is_expire_after_appointment" style="color:red"><br />
                      <small>*วันเปลี่ยนแปลงตามการนัดครั้งที่ 1</small>
                    </i>
                    <br />
                    {{ history.effectivedAt }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-6">
                    <strong>ช่องทางชำระเงิน</strong>
                    <br />
                    {{ history.paymentChannel }}
                  </div>
                  <div class="col-6">
                    <strong>เลขที่ใบงานแจ้งซ่อม</strong>
                    <br />
                    <input
                      v-model="history.maintenanceRequest"
                      :disabled="history.canNotEditMaintenanceRequest"
                      type="text"
                      class="form-control"
                      @keyup.enter="saveMaintenanceRequest(history)"
                    >
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-4">
                    <strong>ยอดที่ชำระ</strong>
                    <br />
                    {{ history.total }}
                    {{ subscriber.package.billingCyclePerUnit }}
                  </div>
                </div>
                <div v-if="!history.isFreeTrial && !history.isRJB2BChannel" class="row">
                  <div v-if="!history.isCancelled" class="col-6">
                    <strong>ใบกำกับภาษี</strong>
                    <br />
                    <span v-if="history.showNoReceiptMessage">
                      Subscription นี้ไม่ออกใบกำกับภาษี</span
                    >
                    <span
                      v-else-if="history.showSendReceiptButton && $isCallCenter"
                      >ยังไม่ออกใบกำกับภาษี</span
                    >
                    <sc-button
                      v-if="
                        !$isCallCenter &&
                          history.showSendReceiptButton &&
                          !history.showNoReceiptMessage
                      "
                      :route="history.sendReceiptRoute"
                      variant="primary"
                      size="sm"
                      >{{ history.textToReceiptPage }}</sc-button
                    >

                    <span v-else-if="!history.showNoReceiptMessage">
                      <sc-button
                        v-if="
                          !$isCallCenter
                        "
                        :route="history.sendReceiptRoute"
                        variant="primary"
                        size="sm"
                      >{{ history.textToReceiptPage }}</sc-button
                      >

                      <a
                        v-if="!history.isOfflineReceipt || (history.isOfflineReceipt && history.offlinePdfKey)"
                        :href="history.pdfUrl"
                        class="view-receipt"
                        target="_blank"
                        >ดูใบกำกับภาษี</a
                      >
                    </span>
                  </div>
                  <div v-else class="col-6">
                    <strong>ใบกำกับภาษี</strong>
                    <br />ถูกยกเลิก
                  </div>
                  <div v-if="history.canRefund" class="col-lg-6">
                    <br />
                    <sc-button
                      size="sm"
                      variant="primary"
                      @click="handleClickRefund(history.id)"
                      >Refund
                    </sc-button>
                  </div>
                  <div v-if="history.cancelledAt" class="col-lg-6">
                    <div class="font-red"> ยกเลิกเมื่อ{{ history.cancelledAt }}</div>
                    <input
                      v-model="history.billingRefundRemark"
                      type="text"
                      class="form-control"
                      @keyup.enter="saveRefundRemark(history)"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-lg-6 info">
              <p>แพ็กเกจ</p>
              <h6>
                <router-link :to="routePackage" class="name">{{ subscriber.package.name }}</router-link>
                <br />
                <small>
                  {{ subscriber.package.qualityText }}
                </small>
                <br />
                <small>
                  <span v-if="originalPrice" class="original-price">{{ originalPrice }}</span>
                  {{ subscriber.package.billingCycle }}
                </small>
                <br />
                (ID: {{ detail.current_package.id }})
              </h6>
              <sc-button
                v-if="showBookServiceButton"
                :class="!hasHome ? 'disabled' : ''"
                variant="secondary"
                @click="handleClickSubscriberBookServicePage(subscriber.id)"
              >นัดบริการ</sc-button>
              <p v-if="!hasHome" class="font-red">กรุณาเลือกแพ็กเกจเข้าบ้าน</p>
              <p style="margin-top: 24px;">บริการ</p>
              <list-service-appointment
                v-for="service in subscriber.services"
                :key="service.id"
                :quality-unit="subscriber.qualityUnit"
                v-bind="service"
              ></list-service-appointment>
              <dot-life-service-list-item
                v-if="subscriber.dotlifeStatus"
                :status-history="subscriber.dotlifeStatus"
              />
            </div>
          </div>
          <list-tax-invoices
            v-if="isShowAddressTaxInvoice"
            :home-id="detail.home_id"
            :is-sent-receipt="histories[0].isReceiptSigned"
            :selected-tax-invoice="detail.user_tax_invoice"
            :value="subscriber.userId"
            class="text-invoice-list"
            @addressTaxInvoice="newAddressTaxInvoice"
            @confirm="handleConfirmAddressTaxInvoice"
            @selectTaxInvoice="selectAddressToInvoice"
          ></list-tax-invoices>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="cancelDialog.isShow"
      title="ยืนยันการยกเลิกสมาชิก"
      width="520px"
      @close="clearCancelDialog"
    >
      <p class="mb-3">การยกเลิกจะสิ้นสุดรอบบิลปัจจุบันและยกเลิกนัดหมายที่เกี่ยวข้อง</p>
      <el-checkbox
        v-model="cancelDialog.skipRefundCash"
        :disabled="!cancelDialogCanSkipRefundCash"
      >ไม่คืนเงิน (เงินสด/2C2P)</el-checkbox>
      <p
        v-if="!cancelDialogCanSkipRefundCash"
        class="text-muted small mb-2"
      >ช่องทางนี้ระบบไม่คืนเงินอัตโนมัติอยู่แล้ว</p>
      <el-checkbox
        v-model="cancelDialog.skipRefundMnc"
        :disabled="!cancelDialogHasMnc"
        class="mb-2"
      >ไม่คืน Morning Coin (MNC)</el-checkbox>
      <p
        v-if="!cancelDialogHasMnc"
        class="text-muted small mb-2"
      >รายการนี้ไม่มีการใช้ MNC</p>
      <div v-if="cancelDialogRequiresReason">
        <p class="mb-1"><strong>เหตุผลการยกเลิก</strong> (บังคับ)</p>
        <el-input
          v-model="cancelDialog.cancelReason"
          type="textarea"
          :rows="3"
          placeholder="ระบุเหตุผลเมื่อเลือกไม่คืนเงินหรือไม่คืน MNC"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <sc-button :disabled="cancelDialog.isSubmitting" @click="clearCancelDialog">ยกเลิก</sc-button>
        <sc-button
          variant="danger"
          :disabled="cancelDialogSubmitDisabled"
          @click="handleConfirmCancel"
        >ยืนยันการยกเลิก</sc-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="selectHomeDialog.isShow"
      title="เลือกบ้านที่จะผูกกับแพ็กเกจ"
      width="50%"
      @close="clearSelectHomeDialog"
    >
      <div v-for="home in selectHomeDialog.homes" :key="home.id">
        <el-radio v-model="selectHomeDialog.selectedHome" :label="home"
          ><strong>บ้านเลขที่:</strong> {{ home.addressNo }}
          <strong>โครงการ:</strong> {{ home.projectName }}</el-radio
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <sc-button @click="clearSelectHomeDialog">ยกเลิก</sc-button>
        <sc-button variant="primary" @click="handleBindSupportedHome">ยืนยัน</sc-button>
      </span>
    </el-dialog>
  </page-wrapper>
</template>

<script>
import ConfirmDialog from "@/components/helper/dialog/ConfirmDialog";
import { baanRueJaiClient, backendAdminClient } from "@/dependencies";
import { getPDF } from "@/god";
import PageWrapper from "@/lib/components/PageWrapper";
import RiLinkButton from "@/lib/components/RiLinkButton";
import ScButton from "@/lib/components/ScButton";
import { getDurationAppointmentTimeText, toLocaleTH } from "@/lib/dateTime";
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString,
  formatNumber
} from "@/lib/formatter";
import {
  permissionRole,
  reversePaymentStatus,
  subscriptionStatus
} from "@/lib/mapper";
import { Checkbox, Dialog, Input, Radio } from "element-ui";
import { DateTime } from "luxon";
import { isEmpty, isNil } from "ramda";
import ListServiceAppointment from "../components/ListServiceAppointment";
import ListTaxInvoices from "../components/ListTaxInvoices";
import DotLifeServiceListItem from "../components/DotLifeServiceListItem";

export default {
  components: {
    ConfirmDialog,
    PageWrapper,
    ScButton,
    ListServiceAppointment,
    DotLifeServiceListItem,
    "el-dialog": Dialog,
    "el-radio": Radio,
    "el-input": Input,
    "el-checkbox": Checkbox,
    ListTaxInvoices,
    RiLinkButton
  },
  data() {
    const title = "รายละเอียดสมาชิก";
    const selectHomeDialog = {
      isShow: false,
      homes: [],
      selectedHome: null
    };
    const cancelDialog = {
      isShow: false,
      skipRefundCash: false,
      skipRefundMnc: false,
      cancelReason: "",
      isSubmitting: false
    };

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      title,
      detail: null,
      subscriber: null,
      payment: null,
      histories: [],
      selectHomeDialog,
      cancelDialog,
      permission,
      isShowAddressTaxInvoice: false,
      newSelectAddress: null,
      decryptedId: null,
      isHiddenDrecryptButton: false,
      confirmDialog: {
        isShow: false,
        action: null,
        payload: null,
        title: '',
        detail: '',
        remark: '',
        buttonSubmit: 'ยืนยัน',
        buttonCancel: 'ยกเลิก'
      }
    };
  },
  computed: {
    originalPrice() {
      const price = this.detail.current_package.original_price;

      if (!price) {
        return null;
      }

      return `${(formatCurrencyAndTwoDecimalsString(price / 100))} บาท`;
    },
    note() {
      const label = this.detail.current_package.note_label;
      const firstHistory = this.detail.histories[
        this.detail.histories.length - 1
      ];
      const content =
        firstHistory && firstHistory.invoice && firstHistory.invoice.note;

      return {
        label,
        content
      };
    },
    showExtras() {
      return !!this.detail.registration_form;
    },
    registrationForm() {
      const form = this.detail.registration_form;
      const {title} = form;

      return {
        title,
        extras: this.extras
      };
    },
    extras() {
      return this.detail.registration_form.sections.map(({ title, inputs }) => {
        const label = title;
        const key = title;

        return {
          key,
          label,
          inputs: inputs.map(input => {
            const isImage = input.type === "CITIZEN_CARD_IMAGE";
            const isText = !isImage;

            return {
              key: input.title,
              label: input.title,
              value: input.value || "-",
              isImage,
              isText
            };
          })
        };
      });
    },
    showNote() {
      return this.note.label && this.note.content;
    },
    showBookServiceButton() {
      return true;
    },
    showCancelAction() {
      if (this.$isCallCenter) {
        return false;
      }

      return this.showCancelButton || this.showUnsubscribeButton;
    },
    showRevokeAction() {
     if (
        this.$isCallCenter
        || (
          this.detail.histories[0].expired_at < new Date().toISOString() &&
          this.status === subscriptionStatus.UNSUBSCRIBED
        ) || this.isBankTransfer
      ) {
        return false;
      }

      return this.showRevokeUnsubscribeButton;
    },
    showCancelButton() {
      return [
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL,
        subscriptionStatus.ONE_TIME
      ].includes(this.status)
      || this.isBankTransfer
    },
    showCancelledDate() {
      return [
        subscriptionStatus.CANCELLED,
        subscriptionStatus.UNSUBSCRIBED,
        subscriptionStatus.EXPIRED
      ].includes(this.status) && !isNil(this.subscriber.cancelledAt);
    },
    showUnsubscribeButton() {
      return this.subscriber.canUnsubscribe;
    },
    showRevokeUnsubscribeButton() {
      return this.status === subscriptionStatus.UNSUBSCRIBED;
    },
    disabledUnsubscribeButton() {
      return !this.showUnsubscribeButton;
    },
    disabledCancelButton() {
      const latestHistory = this.histories[0];
      const isLatestReceiptSigned =
        latestHistory && latestHistory.isReceiptSigned;

      const isStatusAndlatestReceiptSigned = !([
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL,
        subscriptionStatus.ONE_TIME
      ].includes(this.status)) && isLatestReceiptSigned;

      return (isStatusAndlatestReceiptSigned && !this.isBankTransfer) || this.isViewOnlyByRole
    },
    alertDialog() {
      switch (this.status) {
        case subscriptionStatus.FREE_TRIAL:
          return {
            isShow: true,
            message: "ลูกบ้านทดลองใช้งาน"
          };
        case subscriptionStatus.UNSUBSCRIBED:
          return {
            isShow: true,
            message: "ลูกบ้านไม่ Sub ต่อ"
          };
        case subscriptionStatus.CANCELLED:
          return {
            isShow: false,
            message: "ยกเลิกทันที"
          };
        case subscriptionStatus.ACTIVE:
          return {
            isShow: false,
            message: ""
          };
        case subscriptionStatus.ONE_TIME:
          return {
            isShow: false,
            message: ""
          };
        default:
          break;
      }

      if (this.histories.length === 0) {
        return {
          isShow: false,
          message: ""
        };
      }

      const {isReceiptSigned} = this.histories[0];

      if (!isReceiptSigned) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isShow = isReceiptSigned;
      const date = this.histories[0].receiptSignedAt.toFormat(
        "dd MMM yyyy HH:mm"
      );

      const message = `ไม่สามารถ "ยกเลิกทันที" ได้ เนื่องจากออกใบเสร็จไปแล้ว เมื่อ ${date}`;
      return {
        isShow,
        message
      };
    },
    paymentStatus() {
      if (!this.payment) {
        return "กำลังโหลด";
      }

      if (this.payment === "F") {
        return "ไม่สามารถเรียกดูข้อมูลการชำระเงินได้";
      }

      return reversePaymentStatus[this.payment.status];
    },
    showPaymentStatus() {
      if (!this.status) {
        return false;
      }

      return (
        this.status !== subscriptionStatus.FREE_TRIAL && this.subscriber.invoice
      );
    },
    status() {
      if (this.detail === null) {
        return null;
      }

      return this.detail.status;
    },
    routePackage() {
      const {id} = this.detail.current_package

      return { name: "PackageDetailPage", params: { id } };
    },
    isSCBPayment() {
      return this.histories.some(
        history =>
          history.paymentChannel === "SCB_EASY" ||
          history.paymentChannel === "SCB_QR" ||
          history.paymentChannel === "BANK_TRANSFER"
      );
    },
    cancelButtonText() {
      return this.isSCBPayment ? "ยกเลิก" : "ยกเลิกและคืนเงิน";
    },
    isBankTransfer() {
      return this.histories[0] && this.histories[0].paymentChannel === 'BANK_TRANSFER'
      && this.status !== subscriptionStatus.CANCELLED
    },
    hasHome() {
      return !isEmpty(this.subscriber.home.addressNumber)
    },
    isCancelled(){
      return this.histories.some((history) => history.cancelledAt && (history.cancelledAt === history.expiredAt))
    },
    addressTaxInvoice() {
      const newTaxInvoice = this.newSelectAddress;
      const taxInvoice = this.detail.user_tax_invoice;

      let line1 = ''
      if (newTaxInvoice) {
        line1 = newTaxInvoice.line1;
      } else if (taxInvoice) {
        line1 = [ taxInvoice.house_no, taxInvoice.street_address ].join(" ");
      }

      let line2 = ''
      if (newTaxInvoice) {
        line2 = newTaxInvoice.line2;
      } else if (taxInvoice) {
        const tumbon = `ตำบล${taxInvoice.tumbon}`
        const amphur = `อำเภอ${taxInvoice.amphur}`

        line2 = [
          tumbon,
          amphur,
          taxInvoice.province,
          taxInvoice.zip_code
        ].join(" ");
      }

      return { line1, line2 };
    },
    isShowTaxInvoiceButton() {
      return !this.$isCallCenter
        && this.histories && this.histories.length > 0
    },
    isViewOnlyByRole() {
      const roles = ["AC", 'CC']
      return roles.includes(this.permission.role)
    },
    ruejaiIntelligenceLink() {
      return `${process.env.RUEJAI_INTELLIGENCE_HOST}/ruejai-intelligence/users/${this.subscriber.userId}`
    },
    cancelDialogLatestHistory() {
      if (!this.detail || !this.detail.histories.length) {
        return null;
      }

      return this.detail.histories[0];
    },
    cancelDialogHasMnc() {
      const history = this.cancelDialogLatestHistory;

      return Boolean(
        history
        && history.receipt
        && history.receipt.total_coin_amount > 0
      );
    },
    cancelDialogCanSkipRefundCash() {
      if (this.status === subscriptionStatus.FREE_TRIAL) {
        return false;
      }

      const history = this.cancelDialogLatestHistory;

      if (!history || !history.receipt || !history.invoice) {
        return false;
      }

      const paymentChannel = history.invoice.transaction
        ? history.invoice.transaction.payment_channel
        : null;
      const isFreePurchase = history.receipt.total <= 0;
      const isFreePurchaseByUseCoin = isFreePurchase
        && history.receipt.total_coin_amount > 0;

      return paymentChannel === "2C2P"
        && !isFreePurchase
        && !isFreePurchaseByUseCoin;
    },
    cancelDialogRequiresReason() {
      const skipCash = this.cancelDialog.skipRefundCash
        && this.cancelDialogCanSkipRefundCash;
      const skipMnc = this.cancelDialog.skipRefundMnc
        && this.cancelDialogHasMnc;

      return skipCash || skipMnc;
    },
    cancelDialogSubmitDisabled() {
      if (this.cancelDialog.isSubmitting) {
        return true;
      }

      if (
        this.cancelDialogRequiresReason
        && !this.cancelDialog.cancelReason.trim()
      ) {
        return true;
      }

      return false;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();

      await this.setupHistories();
      await this.setupPaymentStatus();
    },
    async setupPaymentStatus() {
      if (this.status === subscriptionStatus.FREE_TRIAL) {
        return;
      }

      if (!this.subscriber.invoice) {
        return;
      }

      try {
        const data = await this.fetchPaymentStatus();

        this.payment = data;
      } catch (error) {
        this.payment = "F";
      }
    },
    async setupData() {
      const data = await this.fetchData();
      this.detail = data;

      const {id} = data;
      const userId = data.owner.user_id;
      const userName = `${data.owner.first_name} ${data.owner.last_name}`;
      const phoneNumber = data.owner.mobile_number || "-";
      const {email} = data.owner.user;
      const isUserForOfflinePurchaseByAdmin = data.owner.is_user_for_offline_purchase_by_admin;
      const isNonVerifySales = data.owner.is_non_verify_sales;
      const identifierNo =
        data.owner.citizen_id !== ""
          ? data.owner.citizen_id
          : data.owner.passport_number;
      const dateOfBirth = !isNil(data.owner.birth_date)
        ? toLocaleTH(DateTime.fromISO(data.owner.birth_date)).toFormat(
            "dd MMMM yyyy"
          )
        : "-";

      const home = {
        addressNumber: data.home ? data.home.address_no : "",
        project: data.project ? data.project.project_name : ""
      };
      const quality = data.quality || 1
      const totalPriceBeforeDiscount = data.total_price !== null && data.total_price >= 0
        ? convertBathToStangAndRoundTwoDecimal(data.total_price)
        : convertBathToStangAndRoundTwoDecimal((data.current_package.price) * quality);
      const price = formatCurrencyAndTwoDecimalsString(totalPriceBeforeDiscount);
      const billingCycle =
        data.current_package.billing_cycle > 1
          ? ` ${  data.current_package.billing_cycle.toLocaleString()  } `
          : " ";

      const cycleUnit = data.current_package.billing_cycle === 0 ? "ครั้ง" : "เดือน";
      const billingCyclePerUnit = ` /${billingCycle}${cycleUnit}`;
      const billingCycleText = `${price} บาท/${billingCyclePerUnit}`;
      const qualityText = `จำนวน ${quality} แพ็คเกจ`;

      const pack = {
        name: data.current_package.name,
        price,
        billingCycle: billingCycleText,
        noteLabel: data.current_package.note_label,
        qualityText,
        billingCyclePerUnit
      };
      const format = "dd MMMM yyyy HH:mm น.";
      const purchasedAt = toLocaleTH(
        DateTime.fromISO(data.purchased_at)
      ).toFormat(format);
      const expiredAt = toLocaleTH(DateTime.fromISO(data.expired_at)).toFormat(
        format
      );
      const cancelledAt =
       data.cancelled_at === data.expired_at
          ? toLocaleTH(DateTime.fromISO(data.cancelled_at)).toFormat(format)
          : null;

      const invoice = data.invoice
        ? {
            id: data.invoice.id.toString().padStart(12, "0")
          }
        : undefined;
      const receipt = data.receipt
        ? {
            id: data.receipt.id.toString().padStart(12, "0"),
            signedAt:
              data.receipt && data.receipt.signed_at
                ? toLocaleTH(DateTime.fromISO(data.receipt.signed_at)).toFormat(
                    "dd MMMM yyyy HH:mm น."
                  )
                : null
          }
        : data.receipt;

      const dotLifeOrder = data.dotlife_order;
      let dotlifeStatus = null;

      if (dotLifeOrder) {
        const createdAt = dotLifeOrder.updated_at
          ? DateTime.fromISO(dotLifeOrder.updated_at)
          : DateTime.fromISO(dotLifeOrder.created_at);

        dotlifeStatus = {
          date: createdAt ? toLocaleTH(createdAt).toFormat("dd MMM yyyy") : "",
          time: createdAt ? toLocaleTH(createdAt).toFormat("HH:mm") : "",
          status: dotLifeOrder.status,
          trackingUrl: dotLifeOrder.tracking_url || "",
        };
      }

      const services = data.services.map((service) => {
        const {
          id: serviceId,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          quota,
          main_option_title: mainOptionTitle,
          extra_option_titles: extraOptionTitles
        } = service;

        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };
        const route = { name: "ServiceDetailPage", params: { id: serviceId } };
        const appointmentCount = data.appointment_count[serviceId]
          ? data.appointment_count[serviceId]
          : 0

        const totalAppointment = data.total_appointment[serviceId]
          ? data.total_appointment[serviceId]
          : 0;
        const currentAppointmentDateEnd = data.current_appointment_date_end[serviceId]
          ? data.current_appointment_date_end[serviceId]
          : null;

        const currentAppointmentTime = getDurationAppointmentTimeText(
          data.current_appointment_date[serviceId],
          currentAppointmentDateEnd
        );

        const currentAppointmentDateTime = data.current_appointment_date[serviceId]
          ? toLocaleTH(DateTime.fromISO(data.current_appointment_date[serviceId]))
              .toFormat("dd MMMM yyyy")
          : null;

        let currentAppointmentDate = !dotLifeOrder ? `ไม่มีการนัด` : null;
        if (currentAppointmentDateTime && currentAppointmentTime) {
          currentAppointmentDate = `${currentAppointmentDateTime} ${currentAppointmentTime}`
        } else if (currentAppointmentDateTime) {
          currentAppointmentDate = currentAppointmentDateTime
        }

        return {
          id: serviceId,
          iconUrl,
          name,
          shortDescription,
          description,
          provider,
          route,
          quota,
          appointmentCount,
          currentAppointmentDate,
          totalAppointment,
          mainOptionTitle,
          extraOptionTitles,
        };
      });

      const effectivedAt = toLocaleTH(
        DateTime.fromISO(data.effectived_at)
      ).toFormat("dd MMMM yyyy HH:mm น.");
      const canUnsubscribe = data.can_unsubscribe;

      const subscriber = {
        id,
        userId,
        name: userName,
        phoneNumber,
        email,
        identifierNo,
        dateOfBirth,
        home,
        package: pack,
        purchasedAt,
        expiredAt,
        cancelledAt,
        effectivedAt,
        invoice,
        receipt,
        services,
        dotlifeStatus,
        qualityUnit: `จำนวน ${quality} หน่วย`,
        isUserForOfflinePurchaseByAdmin,
        isNonVerifySales,
        canUnsubscribe
      };

      this.subscriber = subscriber;
    },
    async setupHistories() {
      if (!this.detail) {
        this.histories = [];
        return;
      }

      const isPermissionCallCenter = this.permission
        && [permissionRole.CC, permissionRole.LMC].includes(this.permission.role);

      this.histories = await Promise.all(this.detail.histories.map(async (h, i) => {
        const isReceiptSigned = h.receipt
          ? Boolean(h.receipt.signed_at)
          : false;
        const no = Math.abs(i - this.detail.histories.length);
        const invoiceNo = h.invoice
          ? h.invoice.id.toString().padStart(12, "0")
          : null;
        const receiptNo =
          (h.receipt && h.receipt.document_number) || "ยังไม่ได้ออกใบเสร็จ";
        const isFreeTrial = !h.invoice && !h.receipt;
        const isCancelled = h.cancelled_at === h.expired_at;
        const showSendReceiptButton = !isFreeTrial && !isCancelled && !isReceiptSigned;
        const sendReceiptRoute = !isFreeTrial && !isCancelled
          ? {
              name: "ReceiptDetailPage",
              params: { id: h.receipt.id }
            }
          : null;
        let paymentChannel = h.invoice
          ? h.invoice.transaction.payment_channel
          : 'Free Trial';

        if (h.receipt.total_coin_amount) {
          const totalCoinAmount = formatNumber(h.receipt.total_coin_amount)
          paymentChannel += ` + MNCs / ${totalCoinAmount} บาท`
        }
        const isVoid = !isNil(h.receipt.void_at);
        const hasDocumentNumber = !isNil(h.receipt.document_number);
        const showNoReceiptMessage = isVoid && !hasDocumentNumber;

        // call center สามารถแก้ไข "เลขที่ใบงานแจ้งซ่อม" ได้ครั้งเดียวเท่านั้น
        const canNotEditMaintenanceRequest = isPermissionCallCenter && h.maintenance_request;

        const pdfUrl = h.receipt && h.receipt.is_offline_receipt && h.receipt.offline_pdf_key
          ? await getPDF(h.receipt.offline_pdf_key, "receipt")
          : h.receipt && h.receipt.pdf_url

        let textToReceiptPage = 'ออกใบกำกับภาษี'
        if (h.receipt && h.receipt.is_offline_receipt) {
          textToReceiptPage = 'ออกใบกำกับภาษีนอกระบบแล้ว'
        } else if (h.receipt && h.receipt.signed_at && h.receipt.document_number) {
          textToReceiptPage = 'ออกใบกำกับภาษีแล้ว'
        }
        let canRefund = false
        const adminRoleCanRefund = [
          permissionRole.ADMIN,
          permissionRole.SADMIN
        ]
        if (
          h.can_refund &&
          adminRoleCanRefund.includes(this.permission.role)
          ) {
          canRefund = true
        }

        const total = `${(formatCurrencyAndTwoDecimalsString(h.receipt.total / 100))} บาท`;
        const isRJB2BChannel = h.invoice
          && h.invoice.transaction
          ? h.invoice.transaction.payment_channel === 'RJB2B'
          : false

        return {
          no,
          invoiceNo,
          receiptNo,
          id: h.id,
          cancelledAt: h.cancelled_at && (h.cancelled_at === h.expired_at)
            ? toLocaleTH(DateTime.fromISO(h.cancelled_at)).toFormat("dd MMMM yyyy")
            : null,
          effectivedAt: toLocaleTH(DateTime.fromISO(h.effectived_at)).toFormat(
            "dd MMMM yyyy"
          ),
          expiredAt: toLocaleTH(DateTime.fromISO(h.expired_at)).toFormat(
            "dd MMMM yyyy"
          ),
          canRefund,
          paymentChannel,
          isReceiptSigned,
          receiptSignedAt:
            h.receipt && h.receipt.signed_at
              ? toLocaleTH(DateTime.fromISO(h.receipt.signed_at))
              : null,
          isCancelled,
          showSendReceiptButton,
          sendReceiptRoute,
          isFreeTrial,
          pdfUrl,
          showNoReceiptMessage,
          maintenanceRequest: h.maintenance_request,
          canNotEditMaintenanceRequest,
          isOfflineReceipt: h.receipt && h.receipt.is_offline_receipt,
          offlinePdfKey: h.receipt && h.receipt.offline_pdf_key,
          textToReceiptPage,
          invoiceId: h.invoice_id,
          total,
          billingRefundRemark: h.billing_refund_remark,
          isRJB2BChannel
        };
      }));
    },
    async fetchData() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.get(
          id
        );

        return response.data.result;
      } catch (error) {
        this.$message.error("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async fetchPaymentStatus() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getPaymentStatus(id);
      return response.data.result;
    },
    handleClickCancel() {
      this.cancelDialog.isShow = true;
      this.cancelDialog.skipRefundCash = false;
      this.cancelDialog.skipRefundMnc = false;
      this.cancelDialog.cancelReason = "";
      this.cancelDialog.isSubmitting = false;
    },
    clearCancelDialog() {
      this.cancelDialog.isShow = false;
      this.cancelDialog.skipRefundCash = false;
      this.cancelDialog.skipRefundMnc = false;
      this.cancelDialog.cancelReason = "";
      this.cancelDialog.isSubmitting = false;
    },
    async handleConfirmCancel() {
      if (this.cancelDialogSubmitDisabled) {
        return;
      }

      const skipCash = this.cancelDialog.skipRefundCash
        && this.cancelDialogCanSkipRefundCash;
      const skipMnc = this.cancelDialog.skipRefundMnc
        && this.cancelDialogHasMnc;
      const payload = {
        refund_cash: !skipCash,
        refund_mnc: !skipMnc
      };

      if (this.cancelDialogRequiresReason) {
        payload.cancel_reason = this.cancelDialog.cancelReason.trim();
      }

      this.cancelDialog.isSubmitting = true;

      try {
        const { id } = this.$route.params;
        await baanRueJaiClient.admin.subscriptions.subscribers.postCancel(
          id,
          payload
        );

        this.clearCancelDialog();

        const willRefundCash = payload.refund_cash
          && this.cancelDialogCanSkipRefundCash;
        const scbManualRefundMessage = this.isSCBPayment && payload.refund_cash;
        const cancelSuccessMessage = willRefundCash
          ? "ยกเลิกและคืนเงินเรียบร้อย"
          : "ยกเลิกเรียบร้อย";

        this.$message.success(
          scbManualRefundMessage
            ? "ยกเลิกเรียบร้อย กรุณาติดต่อฝ่ายบัญชี เพื่อทำเรื่องคืนเงินนอกระบบบ้านรู้ใจ"
            : cancelSuccessMessage
        );
        await this.setup();
      } catch (err) {
        this.$message.error("การยกเลิกผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      } finally {
        this.cancelDialog.isSubmitting = false;
      }
    },
    async executeCancel() {
      try {
        const { id } = this.$route.params;
        await baanRueJaiClient.admin.subscriptions.subscribers.postCancel(id);
        this.$message.success(
          this.isSCBPayment
            ? "ยกเลิกเรียบร้อย กรุณาติดต่อฝ่ายบัญชี เพื่อทำเรื่องคืนเงินนอกระบบบ้านรู้ใจ"
            : "ยกเลิกและคืนเงินเรียบร้อย"
        );
        await this.setup();
      } catch (err) {
        this.$message.error("การยกเลิกผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    handleClickUnsubscribe() {
      this.showConfirm({
        action: 'unsubscribe',
        title: 'ยืนยันยกเลิกการเป็นสมาชิก',
        detail: 'คุณต้องการยกเลิกการเป็นสมาชิกใช่หรือไม่'
      });
    },
    async executeUnsubscribe() {
      try {
        const { id } = this.$route.params;
        await baanRueJaiClient.admin.subscriptions.subscribers.postUnsubscribe(id);
        await this.setupData();
        this.$message.success("ยกเลิกการเป็นสมาชิกเรียบร้อย");
      } catch (err) {
        this.$message.error("ยกเลิกการเป็นสมาชิก ผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    handleClickRefund(historyId) {
      this.showConfirm({
        action: 'refund',
        payload: historyId,
        title: 'ยืนยันการคืนเงิน',
        detail: 'ยืนยันการคืนเงินใช่หรือไม่?'
      });
    },
    async executeRefund(historyId) {
      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.postRefund(historyId);
        await this.setup();
        this.$message.success("Refund เรียบร้อย");
      } catch (err) {
        this.$message.error("Refund ผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async handleClickViewReceiptButton(receiptNo) {
      try {
        const id = receiptNo;
        const response = await baanRueJaiClient.admin.subscriptions.receipts.get(
          id
        );

        window.open(response.data.result, "_blank");
      } catch (err) {
        this.$message.error("ไม่สามารถดูใบกำกับภาษีได้ในขณะนี้ิ");
      }
    },
    async handleClickSeeImage(imageKey) {
      const response = await baanRueJaiClient.downloadImage(imageKey);

      window.open(response.data.url, "_blank");
    },
    async handleClickRevoke() {
      try {
        const { id } = this.$route.params;
        await baanRueJaiClient.admin.subscriptions.subscribers.postRevokeUnsubsribe(id);
        await this.setupData();
        this.$message.success("Undo การยกเลิกเรียบร้อยแล้ว");
      } catch (err) {
        this.$message.error("ไม่สามารถ Undo การยกเลิกได้");
      }
    },
    handleShowSelectHomeDialog() {
      this.selectHomeDialog.isShow = true;

      const subscriberId = this.subscriber.id;

      baanRueJaiClient.admin.subscriptions
        .getSupportedHomes(subscriberId)
        .then(response => {
          this.selectHomeDialog.homes = response.data.result.map(home => ({
            id: home.id,
            addressNo: home.address_no,
            projectName: home.project.name
          }));
        })
        .catch(error => {
          const message = error.response
            ? error.response.data.message
            : error.message;

          this.$message.error(`ไม่สามารถเรียกรายการบ้านได้เนื่องจาก ${message}`);
        });
        this.subscriber.identifierNo = '';
        this.isHiddenDrecryptButton = false;
    },
    handleBindSupportedHome() {
      const home = this.selectHomeDialog.selectedHome;
      if (isNil(home)) {
        this.$message.error("กรุณาเลือกบ้านสำหรับผูกกับแพ็กเกจ");
        return;
      }
      this.selectHomeDialog.isShow = false;
      this.showConfirm({
        action: 'bindHome',
        payload: home,
        title: 'ยืนยันการผูกแพ็กเกจ',
        detail: `บ้านเลขที่: ${home.addressNo} โครงการ: ${home.projectName}`,
        remark: 'กรุณาตรวจสอบบ้านที่เลือก หากทำการยืนยันแล้วจะไม่สามารถกลับมาแก้ไขได้อีก'
      });
    },
    executeBindHome(home) {
      const subscriberId = this.subscriber.id;
      const params = { home_id: home.id };

      baanRueJaiClient.admin.subscriptions
        .bindSupportedHome(subscriberId, params)
        .then(() => {
          this.$message.success("ผูกแพ็กเกจกับบ้านสำเร็จ");
          this.selectHomeDialog.isShow = false;
          this.selectHomeDialog.homes = [];
          this.selectHomeDialog.selectedHome = null;
          this.setupData();
        })
        .catch(error => {
          const message = error.response
            ? error.response.data.message
            : error.message;
          this.$message.error(`ผูกแพ็กเกจกับบ้านไม่สำเร็จเนื่องจาก ${message}`);
        });
    },
    clearSelectHomeDialog() {
      this.selectHomeDialog.isShow = false;
      this.selectHomeDialog.homes = [];
      this.selectHomeDialog.selectedHome = null;
    },
    async saveMaintenanceRequest(history) {
      if (!history.maintenanceRequest || history.maintenanceRequest === "") {
        this.$message.error("ไม่สามารถบันทึกค่าว่างได้");
        return;
      }

      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putMaintenanceRequest(
          history.id,
          { maintenanceRequest: history.maintenanceRequest }
        );

        this.$message.success("บันทึก เลขที่ใบงานแจ้งซ่อม สำเร็จ");
        await this.setup();
      } catch (error) {
        this.$message.error("ไม่สามารถแก้ไข เลขที่ใบงานแจ้งซ่อม ได้");
        await this.setup();
      }
    },
    async handleClickListAddressButton() {
      const params = {
        userId: this.subscriber.userId
      };

      await baanRueJaiClient.admin.subscriptions.subscribers.postGenerateUserTaxInvoice(
        params
      );

      this.isShowAddressTaxInvoice = true;
      this.subscriber.identifierNo = '';
      this.isHiddenDrecryptButton = false;
    },
    handleClickSubscriberBookServicePage(id) {
      this.$router.push({ name: "SubscriberBookServicePage", params: { id } });
    },
    handleConfirmAddressTaxInvoice() {
      this.isShowAddressTaxInvoice = false;
    },
    newAddressTaxInvoice(value) {
      this.newSelectAddress = value;
    },
    async selectAddressToInvoice(
      taxInvoiceId,
      isChangeRecurringTaxAddressEveryMonth
    ) {
      try {
        const history = this.histories[0]
        await baanRueJaiClient.admin.subscriptions.subscribers.putTaxInvoiceToCurrentInvoice(
          {
            invoiceId: history.invoiceId,
            taxInvoiceId,
            isChangeRecurringTaxAddressEveryMonth,
            isSentReceipt: history.isReceiptSigned
          }
        );

        this.$message.success("เปลี่ยนข้อมูลใบกำกับสำหรับใบงานเรียบร้อย");
      } catch (error) {
        this.$message.error("ไม่สามารถ เปลี่ยนข้อมูลใบกำกับสำหรับใบงานได้");
      }

      await this.setup();
    },
    handleClickCancelUserTaxInvoiceByTransactionButton() {
      this.showConfirm({
        action: 'cancelTaxInvoice',
        title: 'ยกเลิกข้อมูลใบกำกับภาษี',
        detail: 'คุณต้องการยกเลิกข้อมูลใบกำกับภาษีหรือไม่'
      });
    },
    async executeCancelTaxInvoice() {
      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putInvoiceToCancelUserTaxInvoice(
          this.histories[0].invoiceId
        );
        this.$message.success("ยกเลิกข้อมูลใบกำกับภาษีเรียบร้อย");
        this.newSelectAddress = null;
        this.detail.user_tax_invoice = null;
      } catch (error) {
        this.$message.error("ไม่สามารถ ยกเลิกข้อมูลใบกำกับภาษีได้");
      }
    },
    async saveRefundRemark(history) {
      if (!history.billingRefundRemark || history.billingRefundRemark === "") {
        this.$message.error("ไม่สามารถบันทึกค่าว่างได้");
        return;
      }

      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putRefundRemarkRequest(
          history.id,
          { billing_refund_remark: history.billingRefundRemark }
        );

        this.$message.success("บันทึก สำเร็จ");
      } catch (error) {
        this.$message.error("ไม่สามารถแก้ไข ได้");
      } finally {
        await this.setup();
      }
    },
    handleClickToSubscriberReportPage() {
      this.$router.push({
        name: "SubscriberReportPage",
        query: { documentNumber: this.subscriber.id }
      });

    },
    async handleDecryptIdCard() {
      try {
        const subscriberId = this.subscriber.id;
        const response = await backendAdminClient.subscriber.getDecryptedIdCard(subscriberId);
        this.subscriber.identifierNo = response.data.result.id_card;
        this.isHiddenDrecryptButton = true;
      } catch (error) {
        this.$message.error("ไม่สามารถเข้าถึงได้");
      }
    },
    showConfirm({ action, payload = null, title, detail = '', remark = '' }) {
      this.confirmDialog = {
        isShow: true,
        action,
        payload,
        title,
        detail,
        remark,
        buttonSubmit: 'ยืนยัน',
        buttonCancel: 'ยกเลิก'
      };
    },
    async handleConfirmDialog(confirmed) {
      const { action, payload } = this.confirmDialog;
      this.confirmDialog.isShow = false;
      if (!confirmed) return;

      if (action === 'cancel') await this.executeCancel();
      else if (action === 'unsubscribe') await this.executeUnsubscribe();
      else if (action === 'refund') await this.executeRefund(payload);
      else if (action === 'bindHome') this.executeBindHome(payload);
      else if (action === 'cancelTaxInvoice') await this.executeCancelTaxInvoice();
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.info {
  border-left: $border;
}

.member h6,
.info h6 {
  margin-bottom: 20px;
}

.history {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: $border;

  font-size: 14px;

  .no {
    font-size: 16px;
    font-weight: bold;
  }
}

.view-receipt {
  display: inline-block;

  border-radius: $border-radius;
  border: $border;
  min-width: 0px;
  padding: 6px $space/ 2;

  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    border-color: $primary-color;

    text-decoration: none;

    background: #eee;
  }

  &:focus:not(:disabled) {
    outline: 0;

    border-color: $primary-color;
  }
}

.extra {
  margin-bottom: 0.5rem;

  > p,
  > h6 {
    font-size: 0.875rem;
  }

  > h6 {
    margin: 0;

    &:empty:before {
      content: "-";
    }
  }
}

.original-price {
  text-decoration: line-through;
}

.tar {
  text-align: right;
}

.invoice-list {
  top: 167px;
  left: 138px;
  width: 1164px;
  height: 684px;

  background: #fcfcfc;
  border-radius: 24px;
  opacity: 1;
}

.disabled {
  pointer-events: none;
  opacity: 0.2;
  background-color: rgb(155, 153, 153);
  border-bottom: 1px solid #696868;
}

.font-red {
  color: rgb(250, 102, 102);
}

.id {
  display: flex;
  justify-content: space-between;
}

.fontsize-14 {
  font-size: 14px;
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.callto-link {
  color: $blue;
  text-decoration: underline;
  &:hover {
    font-weight: bold;
  }
}
</style>
